export default {
  simulationData: 'Simulation data',
  showPreview: 'Preview the simulator recipe',
  selectUnitHeader: 'Unit system',
  timeoutSeconds: 'Max simulation time',
};
